const React = require('react');

const WooCommerceIcon = () => (
  <svg
    width={56}
    height={15}
    viewBox="0 0 56 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_19660_97)">
      <path
        d="M48.7011 10.2016C47.1415 10.2016 46.1017 9.07676 46.1017 7.51004C46.1017 5.94333 47.1623 4.79842 48.7011 4.79842C50.2399 4.79842 51.342 5.94333 51.342 7.51004C51.342 9.07676 50.2607 10.2016 48.7011 10.2016ZM48.7011 14.5C52.8392 14.5 56 11.5273 56 7.51004C56 3.49283 52.8392 0.5 48.7011 0.5C44.5629 0.5 41.4229 3.47274 41.4229 7.51004C41.4229 11.5473 44.5837 14.5 48.7011 14.5ZM33.1051 10.2016C31.5455 10.2016 30.485 9.07676 30.485 7.51004C30.485 5.94333 31.5455 4.79842 33.1051 4.79842C34.6647 4.79842 35.7252 5.94333 35.7252 7.51004C35.7252 9.07676 34.6855 10.2016 33.1051 10.2016ZM33.1051 14.5C37.2224 14.5 40.3832 11.5273 40.404 7.51004C40.404 3.47274 37.2224 0.5 33.1051 0.5C28.9877 0.5 25.8062 3.47274 25.8062 7.51004C25.8062 11.5473 28.9877 14.5 33.1051 14.5ZM7.15336 14.5C8.77534 14.5 10.1062 13.7367 11.0835 11.929L13.2878 7.95194V11.3264C13.2878 13.3149 14.6186 14.5 16.6773 14.5C18.2993 14.5 19.4846 13.8171 20.6283 11.929L25.7022 3.6736C26.8043 1.84577 26.0141 0.5 23.5811 0.5C22.2711 0.5 21.4185 0.901722 20.6491 2.28766L17.1556 8.61478V2.99067C17.1556 1.30344 16.3238 0.5 14.8058 0.5C13.5789 0.5 12.6224 1.00215 11.8737 2.40818L8.58819 8.61478V3.05093C8.58819 1.24319 7.81879 0.5 5.96807 0.5H2.16264C0.727813 0.5 0 1.14275 0 2.32783C0 3.51291 0.769402 4.19584 2.16264 4.19584H3.72224V11.3063C3.72224 13.3149 5.11548 14.5 7.15336 14.5Z"
        fill="#873EFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_19660_97">
        <rect
          width={56}
          height={14}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

module.exports = WooCommerceIcon;
